'use client';

import React from 'react';

import {HeroBanner as SharedHeroBanner} from '@udemy-v2/react-hero-banner';
import {useFeatures} from '@udemy-v2/react-experimentation';

import {MOBILE_WEB_OPTIMIZATION} from '@/app/lib/experimentation';

// Client wrapper: lohp-page.tsx is a Server Component and can't call useFeatures itself.
export const HeroBanner: React.FC = () => {
    const {featureVariantAssignments, isLoading} = useFeatures([MOBILE_WEB_OPTIMIZATION]);
    const isSlimBannerEnabled = Boolean(
        featureVariantAssignments.get(MOBILE_WEB_OPTIMIZATION)?.configuration?.feature,
    );

    return (
        <SharedHeroBanner
            isCareerAcademiesEnabled
            isSlimBannerEnabled={isSlimBannerEnabled}
            isFeaturesLoading={isLoading}
            isAutoplayEnabled={false}
            isRotationControlVisible={false}
        />
    );
};
